module.exports = __webpack_public_path__ + "static/media/Clear.f2bbc5a9.svg";